import { ReactNode } from "react";
import CustomButton from "shared/components/button/CustomButton";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import { Section } from "shared/components/section/Section";
import { FaHome } from "react-icons/fa";
import ModalHistoricoContatosRealizados from "./ModalHistoricoContatosRealizados";
import ModalRegistrarContatoRealizado from "./ModalRegistrarContatoRealizado";

import ScrollElement from "shared/components/scrollElement/ScrollElement";
import { EmailDTO } from "types/dto/EmailDTO";
import { TelefoneDTO } from "types/dto/TelefoneDTO";
import ModalAdicionarContatos from "./ModalAdicionarContatos";
import { useGestaoCobrancaCadastroContext } from "context/gestaoCobranca/GestaoCobrancaCadastroContext";
import { useGetInformacoesUnidade } from "hooks/unidade/useGetInformacoesUnidade";
import { RequestInformacoesUnidade } from "types/request/RequestInfomacoesUnidade";

export const InformacoesUnidade = () => {
  const [showModalRegistrarContato, setShowModalRegistrarContato] = useState<boolean>(false);
  const [showModalHistoricoContatosRealizados, setShowModalHistoricoContatosRealizados] =
    useState<boolean>(false);
  const [showModalAdicionarContato, setShowModalAdicionarContato] = useState<boolean>(false);
  const { unidadeId } = useGestaoCobrancaCadastroContext();

  const requestInformacaoUnidade: RequestInformacoesUnidade = {
    unidadeId: unidadeId,
  };

  const { data: informacoesUnidade } = useGetInformacoesUnidade(requestInformacaoUnidade);

  const renderFooterInformacoesUnidade = (): ReactNode => {
    return (
      <Row>
        <Col className="d-flex justify-content-end">
          <CustomButton
            id="btn-registrar-contato-realizado"
            label="Registrar contato realizado"
            size="sm"
            onClick={() => setShowModalRegistrarContato(true)}
          />

          <div
            className="mt-2 ms-2 cursor-pointer hover-color"
            onClick={() => setShowModalHistoricoContatosRealizados(true)}
          >
            <BsEye size={20} />
            <span className="ms-1">Visualizar histórico de contatos realizados</span>
          </div>
        </Col>
      </Row>
    );
  };

  const renderContentInformacoesUnidade = () => {
    return (
      <Row className="mb-2">
        <Col xs={6}>{renderDadosGerais()}</Col>
        <Col xs={6}>{renderContatos()}</Col>
      </Row>
    );
  };

  const renderDadosGerais = (): ReactNode => {
    return (
      <div className="container-dados-gerais">
        <h2 className="titulo mb-2">Dados gerais</h2>
        <Row className="mb-2">
          <Col xs={6}>
            <h3 className="sub-titulo">Nome</h3>
            <span>{informacoesUnidade?.nomeProprietario}</span>
          </Col>
          <Col xs={6}>
            <h3 className="sub-titulo">{getSubtituloCpfOuCnpj()}</h3>
            <span>{informacoesUnidade?.cpfCnpjProprietarioFormatado}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="sub-titulo">Endereço</h3>
            <span>{informacoesUnidade?.enderecoFormatado}</span>
          </Col>
        </Row>
      </div>
    );
  };

  const renderContatos = (): ReactNode => {
    return (
      <div>
        <div className="d-flex justify-content-between">
          <h2 className="titulo">Contatos</h2>
          {devePermitirAdicionarContatos() && (
            <CustomButton
              className="ms-3 btn-adicionar-contatos"
              id="adicionar-contatos"
              label="Adicionar"
              variant="outline-primary"
              size="sm"
              leftIcon={AiOutlinePlus}
              onClick={() => setShowModalAdicionarContato(true)}
            />
          )}
        </div>
        <Row className="mb-2">
          <Col xs={6}>
            <h3 className="sub-titulo">E-mail</h3>
            <ScrollElement height="100px">{renderEmails()}</ScrollElement>
          </Col>
          <Col xs={6}>
            <h3 className="sub-titulo">Telefone</h3>
            <ScrollElement height="100px">{renderTelefones()}</ScrollElement>
          </Col>
        </Row>
      </div>
    );
  };

  const devePermitirAdicionarContatos = () => {
    if (!informacoesUnidade?.contato?.proprietarioId) {
      return informacoesUnidade?.contato?.emails != null;
    }
    return true;
  };

  const renderEmails = (): ReactNode => {
    if (informacoesUnidade?.contato?.emails && informacoesUnidade.contato?.emails.length > 0) {
      return informacoesUnidade.contato?.emails.map((email: EmailDTO, index: number) => {
        return (
          <span className="display-block" key={`email-informacoes-unidade-${index}`}>
            {email.email}
          </span>
        );
      });
    }

    return <span>-</span>;
  };

  const renderTelefones = (): ReactNode => {
    if (
      informacoesUnidade?.contato?.telefonesProprietario &&
      informacoesUnidade.contato?.telefonesProprietario.length > 0
    ) {
      return informacoesUnidade.contato?.telefonesProprietario.map(
        (telefone: TelefoneDTO, index: number) => {
          return (
            <span className="display-block" key={`telefone-informacoes-unidade-${index}`}>
              {telefone.numeroFormatado}
            </span>
          );
        }
      );
    }

    return <span>-</span>;
  };

  const renderModalRegistrarContatoRealizado = () => {
    return (
      <ModalRegistrarContatoRealizado
        showModal={showModalRegistrarContato}
        onCloseModal={() => setShowModalRegistrarContato(false)}
      />
    );
  };

  const renderModalAdicionarContato = () => {
    return (
      <ModalAdicionarContatos
        contato={informacoesUnidade?.contato}
        showModal={showModalAdicionarContato}
        onCloseModal={() => setShowModalAdicionarContato(false)}
      />
    );
  };

  const getSubtituloCpfOuCnpj = () => {
    if (informacoesUnidade?.cpfCnpjProprietarioFormatado != null) {
      return informacoesUnidade?.proprietarioIsPessoaFisica ? "CPF" : "CNPJ";
    }
    return "";
  };

  const renderModalHistoricoContatosRealizados = () => {
    return (
      <ModalHistoricoContatosRealizados
        showModal={showModalHistoricoContatosRealizados}
        onCloseModal={() => setShowModalHistoricoContatosRealizados(false)}
      />
    );
  };

  return (
    <Section title="Informações da unidade" icon={FaHome} footer={renderFooterInformacoesUnidade()}>
      {renderContentInformacoesUnidade()}
      {renderModalRegistrarContatoRealizado()}
      {renderModalAdicionarContato()}
      {renderModalHistoricoContatosRealizados()}
    </Section>
  );
};
